import { GameEvents } from '../../GameEvents';
import { CharacterAttack } from './CharacterAttack';

export class GunbotLaserBolt extends CharacterAttack {
  trigger() {
    this._scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
      sprite: 'projectile_laserbolt',
      damage: this.damage,
      knockdown: this.knockdown,
      x: this._character.x + 150 * this._character.faceDirection,
      y: this._character.y - 150,
      depth: this._character.y,
      velocity: { x: 1500 * this._character.faceDirection, y: 0 },
    });
    super.trigger();
  }
}
